<template>
  <TableLayout :permissions="['business:creationapply:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" >
      <el-form-item label="申请人昵称" prop="nikeName">
        <el-input v-model="searchForm.nikeName" placeholder="请输入申请人昵称" @keypress.enter.native="search"></el-input>
      </el-form-item>

      <el-form-item label="审核状态" prop="status">
        <el-select
          v-model="searchForm.type"
          placeholder="请选择审核状态"
          clearable
        >
          <el-option v-for="item in status" :key="item.id" :value="item.id" :label="item.label"></el-option>
        </el-select>
      </el-form-item>

      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <!-- <ul class="toolbar" v-permissions="['business:creationapply:delete']">
        <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['business:creationapply:delete']">删除</el-button></li>
      </ul> -->
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        border
        @selection-change="handleSelectionChange"
      >
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column prop="nikeName" label="申请人昵称" align="center" min-width="100px"></el-table-column>
        <el-table-column prop="realname" label="真实姓名" align="center" min-width="100px"></el-table-column>
        <el-table-column prop="sex" label="性别" align="center" min-width="100px">
          <template slot-scope="{row}">
            {{ row.sex==0?'男':row.sex==1?'女':'未知' }}
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="手机号" align="center" min-width="100px"></el-table-column>
        <el-table-column prop="info" label="个人介绍" align="center" min-width="100px"></el-table-column>
        <el-table-column prop="createDate" label="申请时间" align="center" min-width="100px"></el-table-column>
        <el-table-column label="查看申请" align="center" min-width="100px">
          <template slot-scope="{row}">
            <el-button type="text" @click="showDetail(row)">查看</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="realname" label="审核状态" align="center" min-width="100px">
          <template slot-scope="{row}">
            <div v-if="row.status==0" style="color: rgb(232, 160, 69)">待审核</div>
            <div v-else-if="row.status==1">审核通过</div>
            <div v-else style="color: rgb(236, 66, 59)">审核驳回</div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="checkInfo" label="审核备注" min-width="100px"></el-table-column>
        <el-table-column prop="checkDate" label="审核时间" min-width="100px"></el-table-column> -->
        <el-table-column
          v-if="containPermissions(['business:creationapply:update'])"
          label="操作"
          min-width="120"
          fixed="right"
          align="center"
        >
          <template slot-scope="{row}">
            <template v-if="row.status==0">
              <el-button type="text" @click="approveAgree(row.id)" v-permissions="['business:creationapply:update']">通过</el-button>
              <el-button type="text" @click="approveRefuse(row.id)" v-permissions="['business:creationapply:update']">驳回</el-button>
            </template>
            <div v-else>-</div>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
      <OperaCreationApplyDetail ref="operaCreationApplyDetail" />
      <OperaCreationApproveWindow ref="operaCreationApproveWindow" @success="handlePageChange" />
    </template>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaCreationApplyDetail from '@/components/business/OperaCreationApplyDetail'
import OperaCreationApproveWindow from '@/components/business/OperaCreationApproveWindow'
export default {
  name: 'CreationApply',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaCreationApplyDetail, OperaCreationApproveWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        id: '',
        nikeName: '',
        createDate: '',
        editor: '',
        editDate: '',
        isdeleted: '',
        remark: '',
        realname: '',
        sex: '',
        email: '',
        phone: '',
        birthday: '',
        idcard: '',
        idcardImg: '',
        idcardImgBack: '',
        status: '',
        areaId: '',
        addr: '',
        info: '',
        origin: '',
        memberId: '',
        checkInfo: '',
        checkDate: ''
      },
      status: [
      // 0申请中 1申请通过 2申请不通过
        { label: '申请中', id: 0 },
        { label: '申请通过', id: 1 },
        { label: '审核驳回', id: 2 },
      ]
    }
  },
  created () {
    this.config({
      module: '创作中心申请表',
      api: '/business/creationApply',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  },
  methods: {
    showDetail(row) {
      this.$refs.operaCreationApplyDetail.open('申请详情', row)
    },
    approveAgree(id) {
      this.$dialog.messageApprove('确定通过审核？')
        .then(() => {
        })
    },
    approveRefuse(id) {
      // 审核
      this.$refs.operaCreationApproveWindow('审核驳回', { id, mark: '' })
    }
  },
}
</script>
